<template>
  <div class="checkbox-group">
    <label for="checkbox-group" class="top-label">{{ label }}</label>
    <div :class="listClasses" class="checkbox-wrapper">
      <checkbox
        class="checkbox"
        v-for="(option, index) in options"
        :key="index"
        :lightLabel="lightLabel"
        :label="option.label || option.name"
        :value="option.value"
        v-model="source[option.name]"
      />
    </div>
  </div>
</template>
<script>
import Checkbox from "@/components/Checkbox";
export default {
  name: "CheckboxGroup",
  data() {
    return {};
  },
  props: {
    lightLabel: Boolean,
    options: Array,
    listClasses: String,
    label: {
      type: String,
      required: true,
    },
    groupId: {
      type: [String, Number],
      default: null,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  methods: {},
  components: {
    Checkbox,
  },
};
</script>

<style lang="less">
.checkbox-group {
  display: block;
  .checkbox-wrapper {
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 18px;
    .checkbox {
      white-space: nowrap;
    }
  }
 .top-label {
    color: var(--text-grey-primary);
    font-weight: 800;
    cursor: pointer;
    padding: 0 2px 0 0;
    transform: translate(0px, 12px) scale(0.8);
    transform-origin: 0 0;
    margin-bottom: 8px;
  }
}
</style>
